module.exports = __webpack_public_path__ + "static/group-53-8a59b19d3e43d1dff8eb969f9deac52c.svg";